import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { APP_CONFIG, dateFormat } from '../../core';
import { DailyEventItem, StrutEventEnum, StrutEventExtended } from '../../models';
import { DashboardService } from '../../services';
import { BaseComponent, ConvertDatePipe } from '../../shared';


/**
 * Component for list of events in dashboard.
 */
@Component({
	selector: 'dashboard-events',
	templateUrl: './dashboard-events.component.html',
	imports: [
		ConvertDatePipe,
		NgbAccordionModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DashboardEventsComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly dashbrdSrv = inject(DashboardService);
	private readonly config = inject(APP_CONFIG);

	events: DailyEventItem[] = [];
	date: Date | null = null;
	dateFormat = dateFormat();

	readonly PANEL_ID_PREFIX = 'event-panel-';

	private _eventsSub?: Subscription;
	private _dateSub?: Subscription;


	ngOnInit(): void {
		this._eventsSub = this.dashbrdSrv.dailyEvents$.subscribe(list => this.events = list ?? []);
		this._dateSub = this.dashbrdSrv.selectedDate$.subscribe(res => this.date = res);
	}

	/**
	 * Get css class according to event type.
	 */
	eventTypeClass(ev: StrutEventExtended): string {
		switch (ev.type) {
			case StrutEventEnum.ADJUST: return 'strut-adjust';
			case StrutEventEnum.CHANGE: return 'strut-change';
			default: return '';
		}
	}

	/**
	 * Get formatted description of event item.
	 */
	eventItemDesc(item: StrutEventExtended): string {
		return `${item.type} - ${item.caseNumber}, Frame ${item.frameID}`;
	}

	/**
	 * Navigate to tlhex report page.
	 */
	goToReport(planId: string, dateOfAdjust: Date): void {
		globalThis.location.href = `${this.config.tlhexSite}?caseGuid=${planId}&dateOfAdjust=${dateOfAdjust}`;
	}


	ngOnDestroy(): void {
		this._eventsSub?.unsubscribe();
		this._dateSub?.unsubscribe();
	}
}
